function onClick(el: MouseEvent): void {
    if (el.target) {
        (el.target as HTMLElement).focus();
    }
}

export const focusOnClick = {
    mounted(el: HTMLElement) {
        el.addEventListener('click', onClick as any as EventListener);
    },
    unmounted(el: HTMLElement) {
        el.removeEventListener('click', onClick as any as EventListener);
    }
};
